module.exports = __webpack_public_path__ + "img/photo_big.a9eb31fb.png";